import { PlanInterval } from '@dtx-company/true-common/src/types/PlanInterval'

interface GetPriceTextOptions {
  priceInCents?: number
  interval?: PlanInterval
  discountPercent?: number
}

export function getPriceInCentsText(priceInCents?: number): string {
  if (priceInCents === undefined) return ''
  // NOTE: Assuming USD, can add it as an option and default in the future
  return (priceInCents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

function getIntervalText(interval?: PlanInterval): string {
  if (!interval) return ''
  switch (interval) {
    case PlanInterval.MONTHLY:
      return `/month`
    case PlanInterval.YEARLY:
      return `/year`
    default:
      throw new Error(`Unsupported interval given: ${interval}`)
  }
}

function getDiscountPercentText(discountPercent?: number): string {
  if (!discountPercent) return ''
  const roundedDiscount = Math.round(discountPercent * 100)
  if (roundedDiscount === 0) return ''
  return ` (${roundedDiscount}% discount)`
}

/**
 * Takes common price-related data and provides a preferred display text.
 * Each option can be used separately to facilitate wrapping different text
 * styles around each piece of text.
 *
 * Refer to spec file for common examples.
 */
export function getPriceText(options?: GetPriceTextOptions): string {
  options = options || {}
  const priceInCentsText = getPriceInCentsText(options.priceInCents)
  const intervalText = getIntervalText(options.interval)
  const discountPercentText = getDiscountPercentText(options.discountPercent)
  return `${priceInCentsText}${intervalText}${discountPercentText}`
}
